import { withStyles } from '@material-ui/core';

import StoresField from './component';
import styles from './styles';

export default withStyles(styles)(StoresField);
